import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/entities/user.entity';

@Pipe({
  name: 'userRole'
})
export class UserRolePipe implements PipeTransform {

  transform(user: User): string {

    if (!user || user.role == null) {
      return '';
    }

    const roles: { [key: number]: string } = {
      0: 'Patient',
      1: 'Medecin',
      2: 'Secretaire',
      3: 'Administrateur',
      8: 'Assistance'
    };

    return roles[Number(user.role)] || 'Role inconnu';
  }
}